import { useState, useRef } from "react";
import styles from "../../Pages/Appearance/page.module.css";
import down from "../../assets/images/icondropdown.svg";

const FooterWidgetBlock = ({ menuList, index, data, onClick }) => {
    const [open, setOpen] = useState(false);
    const popupRef = useRef(null);

    return (
        <div className={styles.appearanceMenuWidgetBlock}>
            <label>Footer Menu {index + 1}</label>

            {/* TITLE INPUT */}
            <input
                type="text"
                className={styles.footerTitleInput}
                placeholder="Enter title..."
                value={data?.title}
                onChange={(e) =>
                    onClick({ ...data, title: e.target.value }) // ✅ SEND UPDATED TITLE TO PARENT
                }
            />

            {/* DROPDOWN */}
            <div className="dropdown-wrapper">
                <div className="dropdown-header" onClick={() => setOpen(!open)}>
                    <span className="header-title">{data?.menuTitle || "Select Menu"}</span>
                    <span className={`arrow ${open ? "rotate" : ""}`}>
                        <img src={down} alt="arrow" />
                    </span>
                </div>

                {open && (
                    <div className="dropdown-list" ref={popupRef}>
                        {menuList.map((item, idx) => (
                            <label
                                key={idx}
                                className="dropdown-item"
                                onClick={() => {
                                    onClick({ ...data, menuId: item.menuId, menuTitle: item.title }); // ✅ UPDATE MENU VALUE
                                    setOpen(false);
                                }}
                            >
                                <span>{item.title}</span>
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FooterWidgetBlock;
